// extracted by mini-css-extract-plugin
export var disclaimer = "Footer-module--disclaimer--33d6d";
export var flexcontainer = "Footer-module--flexcontainer--0605a";
export var footer = "Footer-module--footer--2d913";
export var icons = "Footer-module--icons--33530";
export var icontext = "Footer-module--icontext--a6144";
export var logo = "Footer-module--logo--2eef9";
export var switchone = "Footer-module--switchone--08528";
export var text = "Footer-module--text--94146";
export var updated = "Footer-module--updated--5da95";